module.exports = __webpack_public_path__ + "static/media/icon-filled-answers.5d293aba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-filled-answers.svg
// module id = 1901
// module chunks = 0